import * as React from 'react';
export const snsSvg = React.forwardRef(function snsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_sns__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.578 16a11.575 11.575 0 1 1-23.15.012A11.575 11.575 0 0 1 27.578 16Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16 27.628c6.422 0 11.627-5.206 11.627-11.628S22.422 4.373 16 4.373C9.578 4.373 4.372 9.578 4.372 16c0 6.422 5.206 11.628 11.628 11.628Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 4.317-2.393 6.866 5.6L16 16Z',
        fill: 'url(#bi_sns__b)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm20.317 13.607 6.865 5.6-.683-.359-6.198-5.054.016-.187Z',
        fill: '#E53121',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 4.317-2.393-.016.187-3.897 2.16L16 16Z',
        fill: '#F08465',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.183 19.208 16 16l.404-.046L26.5 18.848l.684.36Z',
        fill: '#B82B18',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 4.317-2.392-1.11-8.792L16 16Z',
        fill: '#F5B0AC',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M19.2 4.818 16 16l.253-.318 2.895-10.096.052-.768Z',
        fill: '#D47785',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.317 13.608 19.2 4.816l-.058.77 1.008 7.942.167.08Z',
        fill: '#D99E9B',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 4.317-2.393-.167-.087-3.897 2.162L16 16Z',
        fill: '#F9D1CD',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M18.392 20.317 12.8 27.183l.36-.684 5.054-6.198.178.016Z',
        fill: '#F9F9FC',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 2.393 4.317-.187-.016-2.16-3.896L16 16Z',
        fill: '#F3F2F9',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12.8 27.183 16 16l.046.403L13.152 26.5l-.352.684Z',
        fill: '#DCDAEE',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 2.393 4.317 8.79-1.11L16 16Z',
        fill: '#2B2B85',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.183 19.207 16 16l.319.253 10.096 2.895.768.06Z',
        fill: '#484293',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm18.393 20.317 8.79-1.11-.769-.06-7.936 1.003-.085.167Z',
        fill: '#24236F',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16 2.393 4.317.085-.167-2.16-3.897L16 16Z',
        fill: '#8F88C0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-4.317 2.393L4.817 12.8 16 16Z',
        fill: 'url(#bi_sns__c)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M11.683 18.393 4.817 12.8l.684.358 6.2 5.056-.018.179Z',
        fill: '#BBB7DB',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-4.317 2.393.017-.186 3.897-2.16L16 16Z',
        fill: '#B0AAD4',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4.817 12.8 16 16l-.404.047L5.5 13.15l-.684-.35Z',
        fill: '#D1CCE6',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-4.317 2.393 1.117 8.79L16 16Z',
        fill: '#FD0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12.8 27.183 16 16l-.253.319-2.895 10.094-.052.77Z',
        fill: '#DBBB85',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm11.683 18.393 1.117 8.79.06-.77-1.01-7.94-.167-.08Z',
        fill: '#EBC536',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-4.317 2.393.167.086 3.897-2.16L16 16Z',
        fill: '#FFE167',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-2.393-4.317 5.6-6.865L16 16Z',
        fill: '#E53121',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm13.607 11.683 5.6-6.865-.358.683-5.056 6.2-.186-.018Z',
        fill: '#EA583C',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-2.393-4.317.186.016 2.16 3.897L16 16Z',
        fill: '#D42F1E',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M19.2 4.818 16 16l-.047-.404L18.85 5.5l.35-.683Z',
        fill: '#C22C1A',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-2.393-4.317-8.79 1.117L16 16Z',
        fill: '#F3F2F9',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4.817 12.8 16 16l-.319-.254-10.096-2.893-.768-.053Z',
        fill: '#F9F8FB',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13.607 11.683 4.817 12.8l.768.06 7.942-1.01.08-.167Z',
        fill: '#DCDAEE',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm16 16-2.393-4.317-.08.167 2.16 3.896L16 16Z',
        fill: '#F9F9FC',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.37 7.917a11.561 11.561 0 0 0-5.17-3.1l1.111 8.79 4.052-5.69h.006Z',
        fill: 'url(#bi_sns__d)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm19.2 4.818 1.111 8.79.103-.415-1.043-8.326-.17-.05H19.2Z',
        fill: '#8F88C0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm24.26 7.805-3.84 5.382-.103.415 4.054-5.69-.11-.112v.005Z',
        fill: '#A59FCE',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.37 7.917a11.561 11.561 0 0 0-5.17-3.1l.212.388a11.265 11.265 0 0 1 4.655 2.856l.29-.145.012.001Z',
        fill: 'url(#bi_sns__e)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm20.317 13.607 4.052-5.69a11.673 11.673 0 0 1 2.921 5.269l-6.973.421Z',
        fill: 'url(#bi_sns__f)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm24.37 7.917-4.053 5.69.314-.174 3.847-5.4-.107-.116Z',
        fill: '#ED6F50',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.25 13.032-6.619.401-.314.175 6.973-.422-.04-.154Z',
        fill: '#A62714',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.933 13.049a11.387 11.387 0 0 0-2.642-4.758l.074-.372a11.7 11.7 0 0 1 2.92 5.268l-.356-.136.004-.002Z',
        fill: 'url(#bi_sns__g)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm20.317 13.607 6.973-.421a11.57 11.57 0 0 1-.108 6.021l-6.865-5.6Z',
        fill: 'url(#bi_sns__h)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.29 13.186-6.973.421.406.13 6.603-.399a5.546 5.546 0 0 0-.036-.152Z',
        fill: '#D1CEE8',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.182 19.207.045-.164-6.504-5.306-.406-.13 6.865 5.6Z',
        fill: '#F3F2F9',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.964 18.828c.466-1.79.482-3.669.048-5.468l.278-.174a11.57 11.57 0 0 1-.107 6.021l-.219-.38Z',
        fill: 'url(#bi_sns__i)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.917 7.63a11.565 11.565 0 0 0-3.1 5.17l8.79-1.11-5.69-4.06Z',
        fill: 'url(#bi_sns__j)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm4.817 12.8 8.79-1.11-.414-.11-8.326 1.044a3.294 3.294 0 0 0-.05.176Z',
        fill: '#FFCB00',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm7.805 7.74 5.382 3.84.415.103L7.918 7.63l-.114.11Z',
        fill: '#FD0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.917 7.63a11.576 11.576 0 0 0-3.1 5.17l.387-.21a11.271 11.271 0 0 1 2.857-4.654l-.144-.305Z',
        fill: '#FFF8C7',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm13.607 11.683-5.69-4.052a11.686 11.686 0 0 1 5.268-2.92l.42 6.972h.002Z',
        fill: 'url(#bi_sns__k)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm13.434 11.369-.403-6.618v-.002l.154-.039.422 6.973-.173-.314Zm.173.314L7.918 7.631l.114-.11 5.4 3.848.175.314Z',
        fill: '#E53121',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13.05 5.066A11.383 11.383 0 0 0 8.29 7.71l-.372-.074a11.686 11.686 0 0 1 5.267-2.925l-.135.356Z',
        fill: 'url(#bi_sns__l)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm13.607 11.683-.421-6.973a11.577 11.577 0 0 1 6.021.108l-5.6 6.865Z',
        fill: 'url(#bi_sns__m)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm13.185 4.71.42 6.973.132-.406-.399-6.603-.152.036Z',
        fill: '#1E398E',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm19.2 4.818-.163-.047-5.3 6.506-.13.406 5.6-6.865H19.2Z',
        fill: '#2F2482',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M18.828 5.036a11.252 11.252 0 0 0-5.47-.048l-.173-.278a11.577 11.577 0 0 1 6.022.108l-.378.218h-.001Z',
        fill: 'url(#bi_sns__n)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.63 24.083a11.577 11.577 0 0 0 5.17 3.1l-1.11-8.79-4.06 5.69Z',
        fill: '#2B2B85',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm12.8 27.183-1.11-8.79-.103.415 1.044 8.325.169.05Z',
        fill: '#24236F',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm7.74 24.195 3.84-5.382.103-.414-4.053 5.684.11.112Z',
        fill: '#5B549F',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.63 24.083a11.592 11.592 0 0 0 5.17 3.101l-.211-.388a11.266 11.266 0 0 1-4.655-2.857l-.304.144Z',
        fill: 'url(#bi_sns__o)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm11.683 18.393-4.053 5.69a11.7 11.7 0 0 1-2.92-5.268l6.973-.422Z',
        fill: 'url(#bi_sns__p)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm7.63 24.083 4.053-5.69-.314.175-3.848 5.4.11.115Z',
        fill: '#B0AAD4',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm4.75 18.969 6.618-.401.315-.175-6.972.422c.012.052.025.103.04.154Z',
        fill: '#DAD8ED',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5.066 18.951a11.388 11.388 0 0 0 2.643 4.758l-.074.373a11.7 11.7 0 0 1-2.921-5.269l.356.137-.004.002Z',
        fill: 'url(#bi_sns__q)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm11.683 18.393-6.973.422a11.593 11.593 0 0 1 .107-6.015l6.866 5.6v-.007Z',
        fill: '#E53121',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm4.71 18.815 6.973-.422-.406-.13-6.604.4.037.152Z',
        fill: '#CA2D0A',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M5.035 13.18v-.003l-.218-.377 6.866 5.6-.406-.13-6.242-5.09Zm0 0a11.258 11.258 0 0 0-.048 5.469l-.277.173a11.58 11.58 0 0 1 .071-5.892l-.009.035.263.214Z',
        fill: '#ED6F50',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.083 24.37a11.577 11.577 0 0 0 3.1-5.163l-8.79 1.11 5.69 4.053Z',
        fill: 'url(#bi_sns__r)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.182 19.207-8.79 1.11.415.104 8.326-1.045.05-.169Z',
        fill: '#7B73B3',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm24.195 24.26-5.382-3.84-.415-.103 5.69 4.054.113-.11h-.006Z',
        fill: '#D1CEE8',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.083 24.371a11.59 11.59 0 0 0 3.1-5.163l-.387.209a11.261 11.261 0 0 1-2.857 4.654l.145.291-.001.01Z',
        fill: '#655EA5',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm18.393 20.317 5.69 4.053a11.682 11.682 0 0 1-5.269 2.919l-.421-6.972Z',
        fill: 'url(#bi_sns__s)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm18.393 20.317 5.69 4.054-.115.108-5.4-3.847.4 6.618-.154.04-.421-6.973Z',
        fill: '#E53121',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M18.951 26.934a11.403 11.403 0 0 0 4.758-2.643l.372.076a11.71 11.71 0 0 1-5.268 2.92l.137-.357.001.004Z',
        fill: 'url(#bi_sns__t)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm18.392 20.317.422 6.972a11.58 11.58 0 0 1-6.021-.106l5.6-6.866Z',
        fill: 'url(#bi_sns__u)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm18.814 27.29-.421-6.973-.131.406.4 6.604.152-.037Z',
        fill: '#F5B0AC',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm12.8 27.183.164.046 5.306-6.506.13-.406-5.6 6.866Z',
        fill: '#FAD9D5',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13.172 26.965a11.27 11.27 0 0 0 5.47.05l.174.275c-1.982.496-4.06.459-6.022-.107l.378-.218Z',
        fill: 'url(#bi_sns__v)',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__b',
          x1: 19.704,
          y1: 16.731,
          x2: 22.285,
          y2: 19.637,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E53121',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#C22C1A',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__c',
          x1: 1.734,
          y1: 17.429,
          x2: 8.197,
          y2: 24.725,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#DCDAEE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#8F88C0',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__d',
          x1: 24.452,
          y1: 5.32,
          x2: 18.446,
          y2: 4.763,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#7B73B3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#C6C2E2',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__e',
          x1: 26.95,
          y1: 6.215,
          x2: 23.826,
          y2: 1.633,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#6C62A8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#CBCAE6',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__f',
          x1: 18.367,
          y1: 10.664,
          x2: 20.619,
          y2: 16.52,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E53121',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#A62714',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__g',
          x1: 22.866,
          y1: 10.647,
          x2: 27.481,
          y2: 13.23,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E84D2C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#811F08',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__h',
          x1: 18.907,
          y1: 13.518,
          x2: 20.795,
          y2: 21.183,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F3F2F9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#BBB7DB',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__i',
          x1: 26.195,
          y1: 19.681,
          x2: 28.022,
          y2: 19.711,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#fff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#BBB7DB',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__j',
          x1: 4.475,
          y1: 12.345,
          x2: 9.918,
          y2: 16.788,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFF098',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FFD530',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__k',
          x1: 7.326,
          y1: 10.412,
          x2: 14.147,
          y2: 12.065,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F4A286',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E53121',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__l',
          x1: -1158.32,
          y1: -1279.61,
          x2: -1148.93,
          y2: -1250.24,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F4A286',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E53121',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__m',
          x1: 12.331,
          y1: 10.671,
          x2: 17.999,
          y2: 11.754,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#4464AC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#1D3584',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__n',
          x1: 13.259,
          y1: 5.427,
          x2: 19.281,
          y2: 5.427,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#4464AC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.373,
          stopColor: '#2F4B97',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.728,
          stopColor: '#223B89',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#1D3584',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__o',
          x1: 6.061,
          y1: 26.499,
          x2: 10.58,
          y2: 29.788,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#5B62A2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.152,
          stopColor: '#4C579A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.482,
          stopColor: '#31438C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.776,
          stopColor: '#213783',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#1B3380',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__p',
          x1: 4.622,
          y1: 18.639,
          x2: 4.961,
          y2: 24.458,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#fff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#DAD8ED',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__q',
          x1: 3.685,
          y1: 24.543,
          x2: 7.975,
          y2: 24.94,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#fff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#D1CEE8',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__r',
          x1: 17.167,
          y1: 22.22,
          x2: 22.92,
          y2: 26.929,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#D1CEE8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#7B73B3',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__s',
          x1: 15.733,
          y1: 22.519,
          x2: 20.348,
          y2: 27.843,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E53121',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#B02916',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__t',
          x1: 21.54,
          y1: 29.013,
          x2: 24.205,
          y2: 24.251,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E53121',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#9D2511',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__u',
          x1: 13.621,
          y1: 25.783,
          x2: 18.14,
          y2: 28.843,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F5B0AC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#EF8495',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sns__v',
          x1: 12.871,
          y1: 28.028,
          x2: 18.892,
          y2: 28.028,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F5B0AC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#EE788F',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_sns__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(4.363 4.364)',
          d: 'M0 0h24.055v24.056H0z',
        }),
      ),
    ),
  );
});
snsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sns = {
  category: 'brand',
  colorable: false,
  name: 'sns',
  svg: snsSvg,
};
